module.exports = __webpack_public_path__ + "media/images/new_landing/case/emco-hero-1985eb8a0dc38f3115ddc5d2988975c7.jpg";